import React from 'react';
import Swiper from 'react-id-swiper';
import { getTransformationUrl} from '../../../utils/helper';
import styles from './styles.scss';

function ItemDetails (item, printOption) {
  const notAllowed = ['sku_message', 'image_key', 'offer_note'];
  const website = ['title_en', 'brand_code',  'model_name_number', 'variant_en', 'family'];
  const fakeImages = item && (item.image_keys ? item.image_keys.map((image_key) => image_key) : [11, 1, 1, 1].map(() => item.image_key || item.image ));
  const galleryParams = {
    pagination: {
      clickable: true,
      el: '.thumbnailsContainer',
      modifierClass: 'thumbs-',
      bulletClass: 'thumbnailContainer',
      bulletActiveClass: 'thumbnailActive',
      renderBullet: (index, className) => {
        return `<div class="${className}"><div class="imagePreloader"><img src=${item.image_key ? getTransformationUrl(fakeImages[index], '400'):fakeImages[index]} /></div></div>`;
      }
    }
  }

  return (
    <div className={styles.modalView}>
      <div className={styles.imageGallery}>
        {item.sku_message ?
          <p className={styles.alert}>{item.sku_message}</p>:''}
        {item.offer_note ? 
            <p className={styles.alert}>{item.offer_note}</p>:''}
        {fakeImages ? (fakeImages.length > 1 ?
          <Swiper {...galleryParams}>
            {fakeImages.map((image, index) => (
              <div className={styles.imageContainer} key={index}>
                <div className="imagePreloader">
                  <img src={item.image_key ? getTransformationUrl(image) : image} alt={item.title_en} />
                </div>
              </div>
            ))}
          </Swiper>
          :
          <div className={styles.imageContainer}>
            <div className="imagePreloader">
              <img src={getTransformationUrl(fakeImages[0])} alt={item.title_en} />
            </div>
          </div>)
          :
          <div className={styles.imageContainer}>
            <div className="imagePreloader" data-title=" No Image Found">
            </div>
          </div>
        }
      </div>
      <div className={styles.detailsContainer}>
        <div className={styles.detailsTable}>
          <div>
            <h3>Fields for hard-check</h3>
            {Object.keys(item).filter(key => website.includes(key)).map((key, index) => {
              return <p key={index}><span>{key.replace(/_/g,' ')}</span> <span>{item[key] || 'n/a'}</span></p>
            })}
          </div>
          <div>
            <h3>Other details</h3>
            {Object.keys(item).filter(key => !notAllowed.includes(key) && !website.includes(key)).map((key, index) => {
              return <p key={index}><span>{key.replace(/_/g,' ')}</span> <span>{item[key] || 'n/a'}</span></p>
            })}
          </div>
        </div>
        {printOption && printOption}
      </div>
    </div>
  );
}
export default ItemDetails;


// WEBPACK FOOTER //
// ./src/components/common/ModalLayout/ItemDetails.js